export default "__VITE_ASSET__Daeb3cjA__"